import * as actionTypes from '../actions/actionTypes';

const initialState = {
  sidebarIsCollapsed: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_NAVIGATION_SIDEBAR:
      return {
        ...state,
        sidebarIsCollapsed: !state.sidebarIsCollapsed,
      };
    default:
      return state;
  }
};

export default reducer;
